import { render, staticRenderFns } from "./top-left.vue?vue&type=template&id=1e770a96&"
import script from "./top-left.vue?vue&type=script&lang=js&"
export * from "./top-left.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports